import { ListItem, ListItemButton, ListItemText, Stack } from '@mui/material'
import { startCase } from 'lodash'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { ScenarioRun } from 'api'
import GlyphIcon from 'components/common/GlyphIcon'
import Icon from 'components/Icon'
import { InputResultsButton } from 'components/navigation/Notifications/NotificationsList/InputResultsButton'
import { NOTIFICATION_LEFT_PADDING } from 'components/navigation/Notifications/utils'
import { getRunStage } from 'components/scenarios/utils'
import theme from 'theme'

export const CompletedScenarioListItem: React.FC<{
  scenario: ScenarioRun
  doFetch(): void
}> = ({ scenario, doFetch, ...rest }) => {
  const history = useHistory()

  const runStage = getRunStage(scenario)

  const handleClick = (event) => {
    event.preventDefault()

    history.push({
      pathname: `/scenarios/detail/${scenario.scenario_id}/runs/${scenario.run_number}`,
      state: {
        scrollToResults: true
      }
    })

    return false
  }

  return (
    <ListItem
      data-test-completed-scenario
      data-test-notification-item
      disablePadding
      component="div"
      secondaryAction={
        <InputResultsButton doFetch={doFetch} scenario={scenario} />
      }
      {...rest}
    >
      <ListItemButton
        dense
        // note: in this case we can't use a router Link component with the `to` prop
        // because we have a child button component and we need to catch all clicks
        // and ensure we don't navigate when the button is clicked
        onClick={handleClick}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{ pl: NOTIFICATION_LEFT_PADDING, width: '100%' }}
        >
          <GlyphIcon css={{ marginRight: theme.space[3] }}>
            <Icon
              css={{
                fontSize: theme.fontSizes[4],
                color: theme.colors.gray[1]
              }}
              icon="clipboardList"
            />
          </GlyphIcon>

          <ListItemText
            data-test-notification-text
            primary={scenario.name}
            secondary={runStage ? startCase(runStage) : ''}
          />
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
